import { z } from 'zod'

/** Пользователь — поля как в domain.User бэкенда (snake_case, без full_name). */
export const userSchema = z.object({
  id: z.string(),
  email: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  patronymic: z.string().nullable().optional(),
  role: z.string(),
  is_active: z.boolean(),
})
export type User = z.infer<typeof userSchema>

export const tokenPairSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
  /** Секунды до истечения access-токена. */
  expires_in: z.number(),
})
export type TokenPair = z.infer<typeof tokenPairSchema>

export const loginResponseSchema = tokenPairSchema.extend({ user: userSchema })
export type LoginResponse = z.infer<typeof loginResponseSchema>

export const loginRequestSchema = z.object({
  email: z.email('Введите корректный email'),
  password: z.string().min(1, 'Введите пароль'),
})
export type LoginRequest = z.infer<typeof loginRequestSchema>
